import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { ApiService } from '../abstract/api-service.abstract';
import { RegionAssessmentModels } from '../models/region-assessment.models';

@Injectable({
  providedIn: 'root',
})
export class RegionAssessmentService extends ApiService {
  getRegion(): Observable<RegionAssessmentModels> {
    const url = `${this.apiFrontUrl}/dashboard/map-data?date=${this.cacheUid()}`;
    return this.http.get<RegionAssessmentModels>(url);
  }
}
